NtechApp.ChatControls = function($view, chatMessagesForm) {
    var me = this;

    this._$view = null;

    this._ajax = null;
    this._click = null;

    this._messagePrototype = null;

    this._chatMessagesForm = null;
    this._messagesList = null;

    this._messagesQueue = [];
    this._isSavingMessage = false;

    this._construct = function() {
        me._$view = $view;
        me._chatMessagesForm = chatMessagesForm;

        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._messagePrototype = me._$view.attr("data-messagePrototype");

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-sendMessage]", function(event) {
            var $item = $(event.target).closest("[data-sendMessage]");
            if(me.isLocked($item))
                return;

            me._sendMessage();
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

//NtechApp.ChatsControls.EVENT_CHAT_CHANGE = "NtechApp.ChatsList.EventChatChange";

NtechApp.proto(NtechApp.ChatControls, {
    _getSaveMessagesRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_save_message';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_save_message';
    },

    lockControls: function() {
        this._$view.find("[data-lockableUiControl]").addClass("lockedUiControl");
    },

    unlockControls: function() {
        this._$view.find("[data-lockableUiControl]").removeClass("lockedUiControl");
    },

    isLocked: function($item) {
        return $item.hasClass("lockedUiControl");
    },

    setMessagesList: function(messagesList) {
        this._messagesList = messagesList;
    },

    _sendMessage: function() {
        var $messageText = this._$view.find("[data-messageTextarea]");
        var messageText = $.trim($messageText.val());

        if(messageText.length == 0) {
            NtechApp.info.on("Please enter message text");
            return;
        }
        if(messageText.length > 2000) {
            NtechApp.info.on("Max message text is 2000 chars");
            return;
        }

        $messageText.val("");
        var $message = $($.parseHTML(this._messagePrototype));

        $message.find("[data-messageText]").html(
            this._messagesList.escapeMessage(messageText)
        );
        $message.find("[data-messageDate]").text("Just now");

        var $label = $message.find("[data-messageFullname]");
        var $saveLabel = $("<span/>").text("Sending").css({
            paddingLeft: "15px",
            color: "rgb(150,150,150)",
            fontSize: "12px",
            lineHeight: "12px"
        });
        $label.append($saveLabel);

        this._chatMessagesForm.emitOnNewMessageCreateEvent();
        this._messagesList.insertMessage($message);

        this._saveNextMessageText(messageText, $saveLabel, $message);
    },

    _saveNextMessageText: function(message, $saveLabel, $message) {
        this._messagesQueue.push([
            message,
            this._chatMessagesForm.getOpenedChatId(),
            $saveLabel,
            $message
        ]);

        if(this._isSavingMessage)
            return;

        this._saveNextQueuedMessage();
    },

    _saveNextQueuedMessage: function() {
        if(this._messagesQueue.length == 0) {
            this._isSavingMessage = false;
            return;
        }

        this._isSavingMessage = true;
        this._saveNextMessage(this._messagesQueue.shift());
    },

    _saveNextMessage: function(queueEntry) {
        var me = this;
        var message = queueEntry[0];
        var escapedMessage = this._messagesList.escapeMessage(message);
        var chatId = queueEntry[1];

        var params = {
            message: message,
            chatId: chatId
        };

        var $message = queueEntry[3];
        var $saveLabel = queueEntry[2];
        me._ajax.enableTextLoading($saveLabel);

        me._ajax.post({
            url: Routing.generate(me._getSaveMessagesRoute()),
            data: params,
            onSuccess: function(data) {
                me._updateSaveLabel($saveLabel);
                me._updateDates($message, data.messageDate);
                me._updateChatMessageData($message, data.chatId, data.chatMessageId);
                me._chatMessagesForm.emitOnNewMessageSaveEvent(chatId, message, data.messageDate);

                me._saveNextQueuedMessage();
            },
            onError: function(data) {
                var text = "";
                for(var entry in data)
                    text += data[entry];

                NtechApp.info.on(text);
            },
            onComplete: function() {
                //if(me._nextLoadRequestData == null)
                //    me._loaderOff();
            }
        });
    },

    _updateSaveLabel: function($saveLabel) {
        $saveLabel.text("+Message sent").addClass("stopAjaxTextLoading").css({
            color: "#339a99"
        });
        setTimeout(function() {
            $saveLabel.fadeOut(function() { $saveLabel.remove(); });
        }, 1000);
    },

    _updateDates: function($message, newDate) {
        $message.find("[data-datetimeFromUtc]").attr("data-datetimeFromUtc", newDate);
        NtechApp.dateTools.convert($message.find("[data-datetimeFromUtc]"));
    },

    _updateChatMessageData: function($message, chatId, chatMessageId) {
        $message.attr("data-chatModel", chatId);
        $message.attr("data-messageModel", chatMessageId);
    }
});